import React, { FC } from 'react';
import { Table } from './Table';
import { Icon } from './Icon';
import { ProductInfo } from '../types/types';

interface InfoGuidePopUpProps {
  open: boolean;
  onClose: () => void;
  productInfo: ProductInfo;
}

export const InfoGuidePopUp: FC<InfoGuidePopUpProps> = ({
  onClose,
  open,
  productInfo,
}) => {
  if (!open) return <></>;
  return (
    <>
      <div className="z_1000 fixed inset-0 flex items-center justify-center md:px-4">
        <div className="w-full md:h-5/6 h-full md:max-w-3xl flex flex-col bg-white relative z-50 md:rounded-lg rounded-none">
          <div className="relative py-3 md:pl-6 pl-4 border-b">
            <p className="text-12 font-medium">
              상품 정보 고시
              <span className="block font-normal text-gray-400 mt-3">
              전자상거래 등에서의 상품정보제공 고시
              </span>
            </p>
            <button onClick={onClose} className="absolute md:-right-3 md:-top-3 right-3 top-3 bg-gray-800 rounded-full p-1 hover:opacity-80">
              <Icon.X className="wh-4 stroke_white" />
            </button>
          </div>
          <Table className="table border-t-0 border mx-0 md:mx-6 mb-0 md:mb-8 m-auto mt-0 md:mt-5 md:border-t border-0">
            <Table.Head>
              <Table.Row className="divide-x bg-white border-b">
                <Table.Th className="md:py-5 py-2.5  text-12 -px-2">상품 정보 고시 내용</Table.Th>
                <Table.Th className="md:py-5 py-2.5  text-12">상품 정보 고시 값</Table.Th>
              </Table.Row>
            </Table.Head>
            <Table.Body>
              <Table.Row className="divide-x">
                <Table.Td className="md:py-5 py-2.5 ">제품 소재</Table.Td>
                <Table.Td className="md:py-5 py-2.5  overflow-visible whitespace-normal">{productInfo.material}</Table.Td>
              </Table.Row>
              <Table.Row className="divide-x">
                <Table.Td className="md:py-5 py-2.5 ">제품 색상</Table.Td>
                <Table.Td className="md:py-5 py-2.5 ">{productInfo.color}</Table.Td>
              </Table.Row>
              <Table.Row className="divide-x">
                <Table.Td className="md:py-5 py-2.5 ">제조자</Table.Td>
                <Table.Td className="md:py-5 py-2.5 ">{productInfo.manufacturer}</Table.Td>
              </Table.Row>
              <Table.Row className="divide-x">
                <Table.Td className="md:py-5 py-2.5 ">제조국</Table.Td>
                <Table.Td className="md:py-5 py-2.5 ">{productInfo.manufactureCountry}</Table.Td>
              </Table.Row>
              <Table.Row className="divide-x">
                <Table.Td className="md:py-5 py-2.5 ">수입자</Table.Td>
                <Table.Td className="md:py-5 py-2.5 ">{productInfo.importer}</Table.Td>
              </Table.Row>
              <Table.Row className="divide-x">
                <Table.Td className="md:py-5 py-2.5 ">세탁 방법 및 주의 사항</Table.Td>
                <Table.Td className="md:py-5 py-2.5 ">케어라벨 및 고객지원 참조</Table.Td>
              </Table.Row>
              <Table.Row className="divide-x">
                <Table.Td className="md:py-5 py-2.5 ">배송 안내 및 반품 고시</Table.Td>
                <Table.Td className="md:py-5 py-2.5 ">페이지 하단 및 고객지원 참조</Table.Td>
              </Table.Row>
              <Table.Row className="divide-x">
                <Table.Td className="md:py-5 py-2.5 ">제품 제조 연월</Table.Td>
                <Table.Td className="md:py-5 py-2.5 ">{productInfo.productionDate}</Table.Td>
              </Table.Row>
              <Table.Row className="divide-x">
                <Table.Td className="md:py-5 py-2.5 ">품질 보증 기준</Table.Td>
                <Table.Td className="md:py-5 py-2.5 ">관련법 및 소비자 분쟁 해결 규정에 따름</Table.Td>
              </Table.Row>
              <Table.Row className="divide-x">
                <Table.Td className="md:py-5 py-2.5 ">고객 센터 안내</Table.Td>
                <Table.Td className="md:py-5 py-2.5 ">02-541-0854</Table.Td>
              </Table.Row>
            </Table.Body>
          </Table>
        </div>
        <div onClick={onClose} className="bg-littleblack absolute w-full h-full z-1"></div>
      </div>
      <button onClick={onClose} className="element2 w-full py-6 text-center bg-black fixed z_1000 bottom-0 inset-x-0 text-white text-12 mt-10 md:hidden block">닫기</button>
    </>
  );
};
